import { FuseNavigationItem } from '@fuse/components/navigation';

export const defaultNavigation: FuseNavigationItem[] = [
    {
        id: 'ct',
        title: 'Control Tower',
        subtitle: 'Holistic Business View',
        type: 'group',
        icon: 'mat_outline:settings_input_antenna',
        screen_id: 'CLT000',
        view: false,
        add: false,
        update: false,
        delete: false,
        children: [
            {
                id: 'ct.dashboard',
                title: 'Dashboard',
                type: 'basic',
                icon: 'mat_solid:dashboard',
                link: '/control-tower/dashboard',
                screen_id: 'CLT001',
                master_id: 'CLT00',
                view: false,
                add: false,
                update: false,
                delete: false,
            },
            {
                id: 'ct.customer-statistics',
                title: 'Customer Statistics',
                type: 'basic',
                icon: 'mat_solid:monitoring',
                link: '/control-tower/customer-statistics',
                screen_id: 'CLT006',
                master_id: 'CLT00',
                view: false,
                add: false,
                update: false,
                delete: false,
            },
            {
                id: 'ct.vendor-statistics',
                title: 'Vendor Statistics',
                type: 'basic',
                icon: 'mat_solid:storefront',
                link: '/control-tower/vendor-statistics',
                screen_id: 'CLT007',
                master_id: 'CLT00',
                view: false,
                add: false,
                update: false,
                delete: false,
            },
            {
                id: 'ct.performance-evaluation',
                title: 'Performance Evaluation',
                type: 'basic',
                icon: 'mat_solid:assessment',
                link: '/control-tower/performance-evaluation',
                screen_id: 'CLT010',
                master_id: 'CLT00',
                view: false,
                add: false,
                update: false,
                delete: false,
            },
            {
                id: 'ct.sales-analytics-dashboard',
                title: 'Sales Analytics Dashboard',
                type: 'basic',
                icon: 'mat_solid:bar_chart',
                link: '/control-tower/sales-analytics',
                screen_id: 'CLT012',
                master_id: 'CLT00',
                view: false,
                add: false,
                update: false,
                delete: false,
            },
            {
                id: 'ct.performance-kpi-settings',
                title: 'KPI Settings',
                type: 'basic',
                icon: 'mat_solid:tune',
                link: '/control-tower/performance-kpi-settings',
                screen_id: 'CLT011',
                master_id: 'CLT00',
                view: false,
                add: false,
                update: false,
                delete: false,
            },

            {
                id: 'ct.performance',
                title: 'Performance 1',
                type: 'basic',
                icon: 'mat_solid:insights',
                link: '/control-tower/performance',
                screen_id: 'CLT003',
                master_id: 'CLT00',
                view: false,
                add: false,
                update: false,
                delete: false,
            },
            {
                id: 'ct.performance-2',
                title: 'Performance 2',
                type: 'basic',
                icon: 'mat_solid:insights',
                link: '/control-tower/employee-wise-performance',
                screen_id: 'CLT004',
                master_id: 'CLT00',
                view: false,
                add: false,
                update: false,
                delete: false,
            },
            {
                id: 'ct.performance-2',
                title: 'Employee Rewards ',
                type: 'basic',
                icon: 'mat_solid:insights',
                link: '/control-tower/employeerewards/add',
                screen_id: 'CLT005',
                master_id: 'CLT00',
                view: false,
                add: false,
                update: false,
                delete: false,
            },
        ],
    },
    {
        id: 'operations',
        title: 'Operations',
        subtitle: 'Manage Business Operations',
        type: 'group',
        icon: 'heroicons_outline:document',
        view: false,
        add: false,
        update: false,
        delete: false,
        screen_id: 'OPR000',
        children: [
            {
                id: 'comp.company',
                title: 'Company',
                type: 'collapsable',
                icon: 'heroicons_outline:building-office',
                screen_id: 'COM000',
                master_id: 'OPR00',
                view: false,
                add: false,
                update: false,
                delete: false,
                children: [
                    {
                        id: 'comp.company.getallbanks',
                        title: 'Get All Banks',
                        type: 'basic',
                        icon: 'heroicons_solid:building-office-2',
                        link: '/company/getallbanks/manage',
                        screen_id: 'COM001',
                        view: false,
                        add: false,
                        update: false,
                        delete: false,
                        master_id: 'OPR00',
                    },
                    {
                        id: 'comp.company.branch',
                        title: 'Branch Management',
                        type: 'basic',
                        icon: 'heroicons_solid:cube',
                        link: '/company/branch/manage',
                        screen_id: 'COM002',
                        view: false,
                        master_id: 'OPR00',
                        add: false,
                        update: false,
                        delete: false,
                    },
                    {
                        id: 'comp.company.useractivity',
                        title: 'User Activity',
                        type: 'basic',
                        icon: 'heroicons_solid:users',
                        link: '/company/useractivity/report',
                        screen_id: 'COM003',
                        view: false,
                        master_id: 'OPR00',
                        add: false,
                        update: false,
                        delete: false,
                    },
                    {
                        id: 'comp.company.publicholiday',
                        title: 'Public Holiday',
                        type: 'basic',
                        icon: 'heroicons_solid:shield-check',
                        link: '/company/publicholiday/manage',
                        screen_id: 'COM004',
                        view: false,
                        master_id: 'OPR00',
                        add: false,
                        update: false,
                        delete: false,
                    },
                    {
                        id: 'comp.company.exchangerates',
                        title: 'Exchange Rates',
                        type: 'basic',
                        icon: 'heroicons_solid:check-circle',
                        link: '/company/exchange-rates/manage',
                        screen_id: 'COM005',
                        view: false,
                        master_id: 'OPR00',
                        add: false,
                        update: false,
                        delete: false,
                    },
                    // {
                    //   id: 'operations.sales.customer',
                    //   title: 'Maker',
                    //   type: 'basic',
                    //   link: '/masters/maker'
                    // },
                    // {
                    //   id: 'operations.sales.customer',
                    //   title: 'Model',
                    //   type: 'basic',
                    //   link: '/masters/model'
                    // },
                    // {
                    //   id: 'operations.sales.customer',
                    //   title: 'Unit of Measure',
                    //   type: 'basic',
                    //   link: '/masters/uom'
                    // }
                ],
            },
            /*{
                id: 'email',
                title: 'Email Manager',
                subtitle: '',
                type: 'collapsable',
                icon: 'mat_outline:settings_accessibility',
                view: false,
                screen_id: 'EMI000',
                master_id: 'OPR00',
                add: false,
                update: false,
                delete: false,
                children: [
                {
                    id: 'email.email-templates',
                    title: 'Email Template',
                    type: 'basic',
                    icon: 'heroicons_solid:template',
                    link: '/email-manager/email-templates-manage',
                    screen_id: 'EMI001',
                    master_id: 'OPR00',
                    add: false,
                    update: false,
                    delete: false,
                },
                {
                    id: 'email.email-accounts',
                    title: 'Email Accounts',
                    type: 'basic',
                    icon: 'heroicons_solid:mail',
                    link: '/email-manager/email-accounts-manage',
                    screen_id: 'EMI002',
                    master_id: 'OPR00',
                    add: false,
                    update: false,
                    delete: false,
                },
                {
                    id: 'email.email-send-delivered',
                    title: 'Email Send/Delivered Status',
                    type: 'basic',
                    icon: 'heroicons_solid:paper-airplane',
                    link: '/email-manager/email-send-delivered',
                    screen_id: 'EMI003',
                    master_id: 'OPR00',
                    add: false,
                    update: false,
                    delete: false,
                },
                ],
            },*/
            {
                id: 'hrs.team',
                title: 'Team Management',
                type: 'collapsable',
                icon: 'mat_outline:people',
                view: false,
                screen_id: 'TEM000',
                master_id: 'OPR00',
                add: false,
                update: false,
                delete: false,
                children: [
                    {
                        id: 'hrs.team.manage',
                        title: 'Team manager',
                        type: 'basic',
                        icon: 'heroicons_solid:user',
                        link: '/hr/team/manager/manage',
                        screen_id: 'TEM001',
                        view: false,
                        master_id: 'OPR00',
                        add: false,
                        update: false,
                        delete: false,
                    },
                    {
                        id: 'hrs.team.achievement',
                        title: 'Team Achievement',
                        type: 'basic',
                        icon: 'heroicons_solid:hand-thumb-up',
                        link: '/hr/team-achievement/manage',
                        screen_id: 'TEM002',
                        view: false,
                        master_id: 'OPR00',
                        add: false,
                        update: false,
                        delete: false,
                    },
                    {
                        id: 'hrs.team.employee',
                        title: 'Employee Achievement',
                        type: 'basic',
                        icon: 'heroicons_solid:check-circle',
                        link: '/hr/employee-achievement',
                        screen_id: 'TEM003',
                        view: false,
                        master_id: 'OPR00',
                        add: false,
                        update: false,
                        delete: false,
                    },
                ],
            },
            {
                id: 'operations.purchase',
                title: 'Purchase',
                type: 'collapsable',
                icon: 'heroicons_outline:shopping-cart',
                link: '/oprations/purchase',
                children: [
                    {
                        id: 'operations.purchase.manage',
                        title: 'Purchase Order',
                        type: 'basic',
                        icon: 'heroicons_solid:bookmark-square',
                        link: '/purchase/order/manage',
                        screen_id: 'PUR001',
                        view: true,
                        master_id: 'OPR00',
                        add: true,
                        update: true,
                        delete: true,
                    },
                    {
                        id: 'operations.purchase.invoice',
                        title: 'Purchase Invoice',
                        type: 'basic',
                        icon: 'heroicons_solid:bookmark',
                        link: '/purchase/invoice/manage',
                        screen_id: 'PUR002',
                        view: true,
                        master_id: 'OPR00',
                        add: true,
                        update: true,
                        delete: true,
                    },
                    {
                        id: 'operations.purchase.vendor-pre-payment',
                        title: 'Vendor Pre Payment',
                        type: 'basic',
                        icon: 'mat_solid:payments',
                        link: '/purchase/vendor/pre/payment/manage',
                        screen_id: 'PUR003',
                        master_id: 'OPR00',
                        add: false,
                        update: false,
                        delete: false,
                    },
                    {
                        id: 'operations.inv.purchase.invoice',
                        title: 'Inventory Purchase Invoice',
                        type: 'basic',
                        icon: 'mat_solid:trending_up',
                        link: '/purchase/invoice/inventory',
                        screen_id: 'PUR004',
                        view: false,
                        master_id: 'OPR00',
                        add: false,
                        update: false,
                        delete: false,
                    },
                    {
                        id: 'operations.inv.purchase.invoice',
                        title: 'Email Purchase Orders',
                        type: 'basic',
                        screen_id: 'PUR006',
                        icon: 'heroicons_solid:at-symbol',
                        link: '/purchase/email-purchase-orders',
                    },
                    {
                        id: 'operations.inv.purchase.invoice',
                        title: 'Supplier Automation Logs',
                        type: 'basic',
                        icon: 'mat_solid:list_alt',
                        link: '/purchase/supplier-logs',
                        screen_id: 'PUR005',
                        view: false,
                        master_id: 'OPR00',
                        add: false,
                        update: false,
                        delete: false,
                    },
                    {
                        id: 'operations.inv.purchase.return',
                        title: 'Purchase Return',
                        type: 'basic',
                        icon: 'heroicons_solid:receipt-refund',
                        link: '/purchase/return/manage',
                        screen_id: 'PUR007',
                        view: false,
                        master_id: 'OPR00',
                        add: false,
                        update: false,
                        delete: false,
                    },
                    {
                        id: 'operations.inv.purchase.return',
                        title: 'Purchase Transaction Report',
                        type: 'basic',
                        icon: 'heroicons_outline:newspaper',
                        link: '/purchase/transaction/report',
                        screen_id: 'PUR008',
                        view: false,
                        master_id: 'OPR00',
                        add: false,
                        update: false,
                        delete: false,
                    },
                ],
            },
            {
                id: 'operations.sales',
                title: 'Sales',
                type: 'collapsable',
                icon: 'heroicons_outline:tag',
                view: false,
                screen_id: 'SAL000',
                master_id: 'OPR00',
                add: false,
                update: false,
                delete: false,
                children: [
                    {
                        id: 'operations.sales.customer',
                        title: 'Customer Enquiry',
                        type: 'basic',
                        icon: 'mat_solid:note_alt',
                        link: '/sales/customer-enquiry/manage',
                        screen_id: 'SAL001',
                        view: false,
                        master_id: 'OPR00',
                        add: false,
                        update: false,
                        delete: false,
                    },
                    {
                        id: 'operations.sales.order.tender',
                        title: 'Tender',
                        type: 'basic',
                        icon: 'heroicons_solid:document-text',
                        link: '/sales/tender/list',
                        screen_id: 'SAL009',
                        view: false,
                        master_id: 'OPR00',
                        add: false,
                        update: false,
                        delete: false,
                    },
                    {
                        id: 'operations.sales.quotation',
                        title: 'Quotation Management',
                        type: 'basic',
                        icon: 'mat_solid:edit_note',
                        link: '/sales/quotation-management/manage',
                        screen_id: 'SAL002',
                        view: false,
                        master_id: 'OPR00',
                        add: false,
                        update: false,
                        delete: false,
                    },
                    {
                        id: 'operations.sales.order',
                        title: 'Order Management',
                        type: 'basic',
                        icon: 'mat_solid:collections_bookmark',
                        link: '/sales/order-management/manage',
                        screen_id: 'SAL003',
                        view: false,
                        master_id: 'OPR00',
                        add: false,
                        update: false,
                        delete: false,
                    },
                    {
                        id: 'operations.sales.readiness',
                        title: 'Readiness',
                        type: 'basic',
                        icon: 'mat_solid:table_chart',
                        link: '/sales/readiness/list',
                        screen_id: 'SAL010',
                        view: false,
                        master_id: 'OPR00',
                        add: false,
                        update: false,
                        delete: false,
                    },
                    {
                        id: 'operations.sales.readiness-logs',
                        title: 'Readiness Logs',
                        type: 'basic',
                        icon: 'heroicons_solid:inbox',
                        link: '/sales/readiness/list',
                        screen_id: 'SAL010',
                        view: false,
                        master_id: 'OPR00',
                        add: false,
                        update: false,
                        delete: false,
                    },
                    {
                        id: 'operations.sales.forwarding',
                        title: 'Forwarding And Handling',
                        type: 'basic',
                        icon: 'mat_solid:fast_forward',
                        link: '/sales/forwarding-handling/manage',
                        screen_id: 'SAL004',
                        view: false,
                        master_id: 'OPR00',
                        add: false,
                        update: false,
                        delete: false,
                    },
                    {
                        id: 'operations.sales.invoicing',
                        title: 'Invoicing',
                        type: 'basic',
                        icon: 'heroicons_solid:shield-check',
                        link: '/sales/invoicing/manage',
                        screen_id: 'SAL005',
                        view: false,
                        master_id: 'OPR00',
                        add: false,
                        update: false,
                        delete: false,
                    },
                    {
                        id: 'operations.sales.return',
                        title: 'Sales Return',
                        type: 'basic',
                        icon: 'heroicons_solid:chevron-double-left',
                        link: '/sales/order-return/manage',
                        screen_id: 'SAL006',
                        view: false,
                        master_id: 'OPR00',
                        add: false,
                        update: false,
                        delete: false,
                    },
                    {
                        id: 'operations.sales.credit-note',
                        title: 'Credit Note',
                        type: 'basic',
                        icon: 'mat_solid:edit_note',
                        link: '/sales/credit-note/manage',
                        screen_id: 'SAL011',
                        view: false,
                        master_id: 'OPR00',
                        add: false,
                        update: false,
                        delete: false,
                    },
                    {
                        id: 'operations.sales.debit-note',
                        title: 'Debit Note',
                        type: 'basic',
                        icon: 'heroicons_solid:pencil',
                        link: '/sales/debit-note/manage',
                        screen_id: 'SAL012',
                        view: false,
                        master_id: 'OPR00',
                        add: false,
                        update: false,
                        delete: false,
                    },
                    {
                        id: 'operations.sales.order.report',
                        title: 'Sales Order Report',
                        type: 'basic',
                        icon: 'mat_solid:addchart',
                        link: '/sales/order/report',
                        screen_id: 'SAL007',
                        view: false,
                        master_id: 'OPR00',
                        add: false,
                        update: false,
                        delete: false,
                    },
                    {
                        id: 'operations.sales.order.pod',
                        title: 'Pod',
                        type: 'basic',
                        icon: 'mat_solid:podcasts',
                        link: '/sales/pod/manage',
                        screen_id: 'SAL008',
                        view: false,
                        master_id: 'OPR00',
                        add: false,
                        update: false,
                        delete: false,
                    },
                    {
                        id: 'operations.sales.order.agentcomm',
                        title: 'Agent Comm',
                        type: 'basic',
                        icon: 'mat_solid:support_agent',
                        link: '/sales/agent-commission',
                        screen_id: 'SAL010B',
                        view: false,
                        master_id: 'OPR00',
                        add: false,
                        update: false,
                        delete: false,
                    },
                ],
            },
            {
                id: 'clm.claims',
                title: 'Claims',
                type: 'basic',
                icon: 'heroicons_outline:currency-dollar',
                link: '/claims/manage',
                view: false,
                screen_id: 'CLA001',
                master_id: 'OPR00',
                add: false,
                update: false,
                delete: false,
            },
            {
                id: 'operations.income',
                title: 'Income',
                type: 'collapsable',
                icon: 'mat_outline:attach_money',
                view: false,
                screen_id: 'INC000',
                master_id: 'OPR00',
                add: false,
                update: false,
                delete: false,
                children: [
                    {
                        id: 'operations.income.receive-payments',
                        title: 'Receive Payments',
                        type: 'basic',
                        icon: 'mat_solid:payments',
                        link: '/income/receive-payments/manage',
                        screen_id: 'INC001',
                        view: false,
                        master_id: 'OPR00',
                        add: false,
                        update: false,
                        delete: false,
                    },
                    {
                        id: 'operations.income.record-receivables',
                        title: 'Record Receivables',
                        type: 'basic',
                        icon: 'mat_solid:checklist_rtl',
                        link: '/income/record-receivables/manage',
                        screen_id: 'INC002',
                        view: false,
                        master_id: 'OPR00',
                        add: false,
                        update: false,
                        delete: false,
                    },
                    {
                        id: 'operations.income.customer-advances',
                        title: 'Customer Advances',
                        type: 'basic',
                        icon: 'mat_solid:fact_check',
                        link: '/income/customer-advances/manage',
                        screen_id: 'INC003',
                        view: false,
                        master_id: 'OPR00',
                        add: false,
                        update: false,
                        delete: false,
                    },
                    {
                        id: 'operations.income.record-income',
                        title: 'Record Income',
                        type: 'basic',
                        icon: 'mat_solid:library_add_check',
                        link: '/income/record-income/manage',
                        screen_id: 'INC004',
                        view: false,
                        master_id: 'OPR00',
                        add: false,
                        update: false,
                        delete: false,
                    },

                    {
                        id: 'operations.income.customer-advances-applied',
                        title: 'Customer Advance Applied',
                        type: 'basic',
                        icon: 'heroicons_solid:tag',
                        link: '/income/Customer-advances-applied',
                        screen_id: 'INC005',
                        view: false,
                        master_id: 'OPR00',
                        add: false,
                        update: false,
                        delete: false,
                    },
                ],
            },
            {
                id: 'operations.expense',
                title: 'Expense',
                type: 'collapsable',
                icon: 'mat_outline:explicit',
                view: false,
                screen_id: 'EXP000',
                master_id: 'OPR00',
                add: false,
                update: false,
                delete: false,
                children: [
                    {
                        id: 'operations.expense.record',
                        title: 'Record Expense',
                        type: 'basic',
                        icon: 'mat_solid:library_books',
                        link: '/expense/record-exp',
                        screen_id: 'EXP001',
                        view: false,
                        master_id: 'OPR00',
                        add: false,
                        update: false,
                        delete: false,
                    },
                    {
                        id: 'operations.expense.vendorbill',
                        title: 'Vendor Bills Payments',
                        type: 'basic',
                        icon: 'heroicons_solid:banknotes',
                        link: '/expense/vendor/bills/payments',
                        screen_id: 'EXP002',
                        view: false,
                        master_id: 'OPR00',
                        add: false,
                        update: false,
                        delete: false,
                    },
                    {
                        id: 'operations.expense.recordbill',
                        title: 'Record Bills Payable',
                        type: 'basic',
                        icon: 'mat_solid:menu_book',
                        link: '/expense/record/bills/payable',
                        screen_id: 'EXP003',
                        view: false,
                        master_id: 'OPR00',
                        add: false,
                        update: false,
                        delete: false,
                    },
                    {
                        id: 'operations.expense.vendorpayment',
                        title: 'Vendor Advance Payment',
                        type: 'basic',
                        icon: 'heroicons_solid:currency-dollar',
                        link: '/expense/vendor/advance/payment',
                        screen_id: 'EXP004',
                        view: false,
                        master_id: 'OPR00',
                        add: false,
                        update: false,
                        delete: false,
                    },
                ],
            },
            {
                id: 'operations.customer',
                title: 'Customer',
                type: 'collapsable',
                icon: 'heroicons_outline:user',
                view: false,
                screen_id: 'CUS000',
                master_id: 'OPR00',
                add: false,
                update: false,
                delete: false,
                children: [
                    {
                        id: 'operations.customer.management',
                        title: 'Customer Management',
                        type: 'basic',
                        icon: 'heroicons_solid:check-circle',
                        link: '/customer/customer-management/manage',
                        screen_id: 'CUS001',
                        view: false,
                        master_id: 'OPR00',
                        add: false,
                        update: false,
                        delete: false,
                    },
                    {
                        id: 'operations.customer.soa',
                        title: 'Customer SOA',
                        type: 'basic',
                        icon: 'heroicons_solid:document-chart-bar',
                        link: '/customer/soa',
                        screen_id: 'CUS002',
                        view: false,
                        master_id: 'OPR00',
                        add: false,
                        update: false,
                        delete: false,
                    },

                    {
                        id: 'operations.customer.receivables.age',
                        title: 'Customer Receivables ',
                        type: 'basic',
                        icon: 'heroicons_solid:receipt-percent',
                        link: '/customer/account-receivable',
                        screen_id: 'CUS003',
                        master_id: 'OPR00',
                        view: false,
                        add: false,
                        update: false,
                        delete: false,
                    },
                    {
                        id: 'operations.customer.receivables',
                        title: 'Get Pending Receivables',
                        type: 'basic',
                        icon: 'heroicons_solid:document-text',
                        link: '/customer/get/receivables',
                        screen_id: 'CUS004',
                        view: false,
                        master_id: 'OPR00',
                        add: false,
                        update: false,
                        delete: false,
                    },
                    {
                        id: 'operations.customer.receivables.age',
                        title: 'Customer Receivables Age Analysis',
                        type: 'basic',
                        icon: 'heroicons_solid:document',
                        link: '/customer/receivables/analysis',
                        screen_id: 'CUS005',
                        view: false,
                        master_id: 'OPR00',
                        add: false,
                        update: false,
                        delete: false,
                    },
                    {
                        id: 'operations.customer.soa.balance',
                        title: 'Customer SOA Balance',
                        type: 'basic',
                        icon: 'heroicons_solid:document-chart-bar',
                        link: '/customer/soa/balance',
                        screen_id: 'CUS006',
                        view: false,
                        master_id: 'OPR00',
                        add: false,
                        update: false,
                        delete: false,
                    },
                    // {
                    //   id: 'operations.customer.due',
                    //   title: 'Get Pending Invoices',
                    //   type: 'basic',
                    //   link: '/customer/get/pending-invoices',
                    //   screen_id: 'CUS007',
                    //   view: false,
                    //   master_id: 'OPR00',
                    //   add: false,
                    //   update: false,
                    //   delete: false,
                    // },
                    // {
                    //   id: 'operations.sales.customer',
                    //   title: 'Equipment',
                    //   type: 'basic',
                    //   link: '/masters/equipment'
                    // },
                    // {
                    //   id: 'operations.sales.customer',
                    //   title: 'Maker',
                    //   type: 'basic',
                    //   link: '/masters/maker'
                    // },
                    // {
                    //   id: 'operations.sales.customer',
                    //   title: 'Model',
                    //   type: 'basic',
                    //   link: '/masters/model'
                    // },
                    // {
                    //   id: 'operations.sales.customer',
                    //   title: 'Unit of Measure',
                    //   type: 'basic',
                    //   link: '/masters/uom'
                    // }
                ],
            },
            {
                id: 'operations.vendors',
                title: 'Vendors',
                type: 'collapsable',
                icon: 'heroicons_outline:academic-cap',
                view: false,
                screen_id: 'VEN000',
                master_id: 'OPR00',
                add: false,
                update: false,
                delete: false,
                children: [
                    {
                        id: 'operations.vendors.supplier',
                        title: 'Supplier Management',
                        type: 'basic',
                        icon: 'mat_solid:add_comment',
                        link: '/vendors/supplier-management/manage',
                        screen_id: 'VEN001',
                        view: false,
                        master_id: 'OPR00',
                        add: false,
                        update: false,
                        delete: false,
                    },
                    {
                        id: 'operations.vendors.soa',
                        title: 'Vendor SOA',
                        type: 'basic',
                        icon: 'mat_solid:description',
                        link: '/vendors/soa',
                        screen_id: 'VEN002',
                        view: false,
                        master_id: 'OPR00',
                        add: false,
                        update: false,
                        delete: false,
                    },
                    {
                        id: 'operations.vendors.pendingpayables',
                        title: 'Pending Payables',
                        type: 'basic',
                        icon: 'heroicons_solid:document-text',
                        link: '/vendors/pending-payables',
                        screen_id: 'VEN003',
                        view: false,
                        master_id: 'OPR00',
                        add: false,
                        update: false,
                        delete: false,
                    },
                    {
                        id: 'operations.vendors.payableageanalysis',
                        title: 'Vendor Payable Age Analysis',
                        type: 'basic',
                        icon: 'heroicons_solid:document',
                        link: '/vendors/payable-age-analysis',
                        screen_id: 'VEN004',
                        view: false,
                        master_id: 'OPR00',
                        add: false,
                        update: false,
                        delete: false,
                    },
                    // {
                    //   id: 'operations.vendors.supplierbalance',
                    //   title: 'Supplier Balance Summary',
                    //   type: 'basic',
                    //   link: '/vendors/balance-summary',
                    //   screen_id: 'VEN005',
                    //   view: false,
                    //   master_id: 'OPR00',
                    //   add: false,
                    //   update: false,
                    //   delete: false,
                    // },
                    /* {
                  id: 'operations.sales.customer',
                  title: 'Unit of Measure',
                  type: 'basic',
                  icon: 'heroicons_outline:document-duplicate',
                  link: '/masters/uom',
                  screen_id: 'VEN006',
                  view: false,
                  master_id: 'OPR00',
                  add: false,
                  update: false,
                  delete: false,
                },*/
                ],
            },
            {
                id: 'operations.masters',
                title: 'Masters',
                type: 'collapsable',
                icon: 'feather:database',
                view: false,
                screen_id: 'MAS000',
                master_id: 'OPR00',
                add: false,
                update: false,
                delete: false,
                children: [
                    {
                        id: 'operations.sales.customer',
                        title: 'Ship Details',
                        type: 'basic',
                        icon: 'heroicons_solid:identification',
                        link: '/masters/ship/manage',
                        screen_id: 'MAS001',
                        view: false,
                        master_id: 'OPR00',
                        add: false,
                        update: false,
                        delete: false,
                    },
                    {
                        id: 'operations.sales.customer',
                        title: 'Equipment',
                        type: 'basic',
                        icon: 'heroicons_solid:plus-circle',
                        link: '/masters/equipment/manage',
                        screen_id: 'MAS002',
                        view: false,
                        master_id: 'OPR00',
                    },
                    {
                        id: 'operations.sales.customer',
                        title: 'Maker',
                        type: 'basic',
                        icon: 'mat_solid:create',
                        link: '/masters/maker/manage',
                        screen_id: 'MAS003',
                        view: false,
                        master_id: 'OPR00',
                        add: false,
                        update: false,
                        delete: false,
                    },
                    {
                        id: 'operations.sales.customer',
                        title: 'Model',
                        type: 'basic',
                        icon: 'heroicons_solid:pencil-square',
                        link: '/masters/model/manage',
                        screen_id: 'MAS004',
                        view: false,
                        master_id: 'OPR00',
                        add: false,
                        update: false,
                        delete: false,
                    },
                    {
                        id: 'operations.sales.customer',
                        title: 'Fixed Supplier',
                        type: 'basic',
                        icon: 'heroicons_solid:arrow-trending-up',
                        link: '/masters/fixed-supplier/manage',
                        screen_id: 'MAS010',
                        view: false,
                        master_id: 'OPR00',
                        add: false,
                        update: false,
                        delete: false,
                    },
                    {
                        id: 'operations.sales.customer',
                        title: 'Tax Master',
                        type: 'basic',
                        icon: 'heroicons_solid:user',
                        link: '/masters/tax-master/manage',
                        screen_id: 'MAS005',
                        view: false,
                        master_id: 'OPR00',
                        add: false,
                        update: false,
                        delete: false,
                    },

                    {
                        id: 'operations.sales.customer',
                        title: 'Unit of Measure',
                        type: 'basic',
                        icon: 'heroicons_solid:document-duplicate',
                        link: '/masters/uom/manage',
                        screen_id: 'VEN006',
                        view: false,
                        master_id: 'OPR00',
                        add: false,
                        update: false,
                        delete: false,
                    },
                    {
                        id: 'operations.masters.courier',
                        title: 'Courier',
                        type: 'basic',
                        icon: 'heroicons_solid:truck',
                        link: '/masters/courier/manage',
                        screen_id: 'MAS006',
                        view: false,
                        master_id: 'OPR00',
                        add: false,
                        update: false,
                        delete: false,
                    },

                    {
                        id: 'operations.sales.customer',
                        title: 'Excel Customer Enquiry Confrimation',
                        type: 'basic',
                        icon: 'mat_solid:table_chart',
                        link: '/masters/excel-enquiry',
                        screen_id: 'MAS007',
                        view: false,
                        master_id: 'OPR00',
                        add: false,
                        update: false,
                        delete: false,
                    },
                    {
                        id: 'operations.sales.customer',
                        title: 'Audit Reports',
                        type: 'basic',
                        icon: 'mat_solid:add_to_photos',
                        link: '/masters/audit-reports',
                        screen_id: 'MAS012',
                        view: false,
                        master_id: 'OPR00',
                        add: false,
                        update: false,
                        delete: false,
                    },
                ],
            },
            {
                id: 'operations.configurations',
                title: 'Configurations',
                type: 'collapsable',
                icon: 'mat_outline:settings',
                view: false,
                screen_id: 'COF000',
                master_id: 'OPR00',
                add: false,
                update: false,
                delete: false,
                children: [
                    {
                        id: 'operations.configurations.master-data-config.currencies',
                        title: 'Currencies',
                        type: 'basic',
                        icon: 'mat_solid:attach_money',
                        link: '/master-data-config/currencies/manage',
                        screen_id: 'COF001',
                        view: false,
                        master_id: 'OPR00',
                        add: false,
                        update: false,
                        delete: false,
                    },
                    {
                        id: 'operations.configurations.master-data-config.payment-terns',
                        title: 'Payment Terms',
                        type: 'basic',
                        icon: 'mat_solid:credit_card',
                        link: '/master-data-config/payment-terms/manage',
                        screen_id: 'COF002',
                        view: false,
                        master_id: 'OPR00',
                        add: false,
                        update: false,
                        delete: false,
                    },
                    {
                        id: 'operations.configurations.master-data-config.shipping-terms',
                        title: 'Shipping Terms',
                        type: 'basic',
                        icon: 'heroicons_solid:document-text',
                        link: '/master-data-config/shipping-terms/manage',
                        screen_id: 'COF003',
                        view: false,
                        master_id: 'OPR00',
                        add: false,
                        update: false,
                        delete: false,
                    },
                    {
                        id: 'operations.configurations.master-data-config.supply-source',
                        title: 'Supply Source',
                        type: 'basic',
                        icon: 'heroicons_solid:shield-check',
                        link: '/master-data-config/supply-source/manage',
                        screen_id: 'COF004',
                        view: false,
                        master_id: 'OPR00',
                        add: false,
                        update: false,
                        delete: false,
                    },
                    {
                        id: 'operations.configurations.master-data-config.countries',
                        title: 'Countries',
                        type: 'basic',
                        icon: 'heroicons_solid:check-badge',
                        link: '/master-data-config/countries/manage',
                        screen_id: 'COF005',
                        view: false,
                        master_id: 'OPR00',
                        add: false,
                        update: false,
                        delete: false,
                    },
                ],
            },
            {
                id: 'operations.intercompany',
                title: 'Inter Company Payments',
                type: 'collapsable',
                icon: 'mat_outline:wifi_protected_setup',
                link: '',
                view: false,
                screen_id: 'ICP001',
                master_id: 'ICPM001',
                add: false,
                update: false,
                delete: false,
                children: [
                    {
                        id: 'operations.intercompany.manage',
                        title: 'Manage',
                        type: 'basic',
                        icon: 'mat_solid:info',
                        link: '/sales/intercompany-payments/manage',
                        screen_id: 'ICP002',
                        view: false,
                        master_id: 'ICPM001',
                        add: false,
                        update: false,
                        delete: false,
                    },
                    {
                        id: 'operations.intercompany.manage',
                        title: 'Interco Receivable',
                        type: 'basic',
                        icon: 'heroicons_solid:currency-euro',
                        link: '/sales/intercompany-payments/pending-receivable',
                        screen_id: 'ICP003',
                        view: false,
                        master_id: 'ICPM001',
                        add: false,
                        update: false,
                        delete: false,
                    },
                    {
                        id: 'operations.intercompany.manage',
                        title: 'Interco Payable',
                        type: 'basic',
                        icon: 'heroicons_solid:currency-dollar',
                        link: '/sales/intercompany-payments/pending-payable',
                        screen_id: 'ICP004',
                        view: false,
                        master_id: 'ICPM001',
                        add: false,
                        update: false,
                        delete: false,
                    },
                    {
                        id: 'operations.intercompany.manage',
                        title: 'interco Receipt',
                        type: 'basic',
                        icon: 'heroicons_solid:currency-pound',
                        link: '/sales/intercompany-payments/receivable/receipt',
                        screen_id: 'ICP005',
                        view: false,
                        master_id: 'ICPM001',
                        add: false,
                        update: false,
                        delete: false,
                    },
                    // {
                    //   id: 'operations.intercompany.manage',
                    //   title: 'interco payble transaction',
                    //   type: 'basic',
                    //   link: '/sales/intercompany-payments/payable/receipt',
                    //   screen_id: 'ICP006',
                    //   view: false,
                    //   master_id: 'ICPM001',
                    //   add: false,
                    //   update: false,
                    //   delete: false,
                    // },

                    {
                        id: 'operations.intercompany.manage',
                        title: 'Interco Branch Receivable',
                        type: 'basic',
                        icon: 'heroicons_solid:currency-dollar',
                        link: '/sales/inter-company/branchwise/pending-receivable',
                        screen_id: 'ICP007',
                        view: false,
                        master_id: 'ICPM001',
                        add: false,
                        update: false,
                        delete: false,
                    },
                    {
                        id: 'operations.intercompany.manage',
                        title: 'Interco Branch Payable',
                        type: 'basic',
                        icon: 'heroicons_solid:check-badge',
                        link: '/sales/inter-company/branchwise/pending-payable',
                        screen_id: 'ICP008',
                        view: false,
                        master_id: 'ICPM001',
                        add: false,
                        update: false,
                        delete: false,
                    },
                ],
            },
            {
                id: 'operations.automation',
                title: 'Automation',
                type: 'collapsable',
                icon: 'mat_outline:wifi_protected_setup',
                view: false,
                screen_id: 'AT001',
                master_id: 'OPR00',
                add: false,
                update: false,
                delete: false,
                children: [
                    {
                        id: 'operations.sales.customer',
                        title: 'Procureship',
                        type: 'basic',
                        icon: 'heroicons_solid:bookmark-square',
                        link: '/masters/procureship-enquiry',
                        screen_id: 'AT008',
                        view: false,
                        master_id: 'OPR00',
                        add: false,
                        update: false,
                        delete: false,
                    },
                    {
                        id: 'operations.sales.customer',
                        title: 'Ship Serve Enquiry',
                        type: 'basic',
                        icon: 'heroicons_solid:chart-bar',
                        link: '/masters/ship-serve-enquiry',
                        screen_id: 'AT008A',
                        view: false,
                        master_id: 'OPR00',
                        add: false,
                        update: false,
                        delete: false,
                    },
                    {
                        id: 'operations.sales.customer',
                        title: 'Sis commerce',
                        type: 'basic',
                        icon: 'heroicons_solid:chart-bar-square',
                        link: '/masters/sis-commerce',
                        screen_id: 'AT009',
                        view: false,
                        master_id: 'OPR00',
                        add: false,
                        update: false,
                        delete: false,
                    },
                    {
                        id: 'operations.sales.customer',
                        title: 'Mespas Enquiry',
                        type: 'basic',
                        icon: 'heroicons_solid:clipboard-document-check',
                        link: '/masters/mespas-enquiry',
                        screen_id: 'AT009A',
                        view: false,
                        master_id: 'OPR00',
                        add: false,
                        update: false,
                        delete: false,
                    },
                    {
                        id: 'operations.sales.customer',
                        title: 'SeaProc Enquiry',
                        type: 'basic',
                        icon: 'mat_solid:content_copy',
                        link: '/masters/seaproc-enquiry',
                        screen_id: 'AT009B',
                        view: false,
                        master_id: 'OPR00',
                        add: false,
                        update: false,
                        delete: false,
                    },
                ],
            },
        ],
    },
    {
        id: 'acc',
        title: 'Accounting',
        subtitle: 'Ledger & Journals',
        type: 'group',
        icon: 'mat_outline:account_balance',
        view: false,
        screen_id: 'ACC000',
        add: false,
        update: false,
        delete: false,
        children: [
            // {
            //   id: 'acc.accounting',
            //   title: 'Accounting',
            //   type: 'collapsable',
            //   icon: 'heroicons_outline:bell',
            //   screen_id: 'ACC011',
            //   add: false,
            //   update: false,
            //   delete: false,
            //   children: [
            {
                id: 'acc.Balance ',
                title: 'Trial Balance',
                type: 'basic',
                icon: 'heroicons_solid:newspaper',
                link: '/accounting/trial-balance',
                screen_id: 'ACC001',
                view: false,
                master_id: 'ACC000',
            },
            // {
            //   id: 'acc.trail-balance-detailed',
            //   title: 'Trail Balance Detailed',
            //   type: 'basic',
            //   icon: 'heroicons_outline:identification',
            //   link: '/accounting/trail-balance-detailed',
            //   screen_id: 'ACC002',
            //   view: false,
            //   master_id: 'ACC000',
            //   add: false,
            //   update: false,
            //   delete: false,
            // },
            // {
            //   id: 'acc.trail-balance-grouped',
            //   title: 'Trail Balance Grouped',
            //   type: 'basic',
            //   icon: 'heroicons_outline:user-group',
            //   link: '/accounting/trail-balance-grouped',
            //   screen_id: 'ACC003',
            //   view: false,
            //   master_id: 'ACC000',
            //   add: false,
            //   update: false,
            //   delete: false,
            // },
            {
                id: 'acc.funds-transfer',
                title: 'Funds Transfer',
                type: 'basic',
                icon: 'heroicons_solid:receipt-refund',
                link: '/accounting/funds-transfer-manage',
                screen_id: 'ACC004',
                view: false,
                add: false,
                update: false,
                delete: false,
            },
            {
                id: 'acc.ledger-account-setup',
                title: 'Ledger Account Setup',
                type: 'basic',
                icon: 'heroicons_solid:user-circle',
                link: '/accounting/ledger-account-setup-manage',
                screen_id: 'ACC005',
                view: false,
                master_id: 'ACC000',
                add: false,
                update: false,
                delete: false,
            },
            {
                id: 'acc.journal',
                title: 'Journal Entry',
                type: 'basic',
                icon: 'heroicons_solid:newspaper',
                link: '/accounting/journal-entry-manage',
                screen_id: 'ACC007',
                view: false,
                master_id: 'ACC000',
                add: false,
                update: false,
                delete: false,
            },
            {
                id: 'acc.account-balance',
                title: 'Account Balance',
                type: 'basic',
                icon: 'heroicons_solid:credit-card',
                link: '/accounting/account-balance',
                screen_id: 'ACC008',
                view: false,
                master_id: 'ACC000',
                add: false,
                update: false,
                delete: false,
            },
            {
                id: 'acc.ledger',
                title: 'Ledger Accounts',
                type: 'basic',
                icon: 'heroicons_solid:user',
                link: '/accounting/ledger-accounts',
                screen_id: 'ACC009',
                view: false,
                master_id: 'ACC000',
                add: false,
                update: false,
                delete: false,
            },
            {
                id: 'acc.ledger',
                title: 'Account Ledger',
                type: 'basic',
                icon: 'mat_solid:money',
                link: '/accounting/account-ledger',
                screen_id: 'ACC016',
                view: false,
                master_id: 'ACC000',
                add: false,
                update: false,
                delete: false,
            },
            {
                id: 'acc.general-ledger-account',
                title: 'General Ledger By Account',
                type: 'basic',
                icon: 'heroicons_solid:book-open',
                link: '/accounting/general-ledger-account',
                screen_id: 'ACC0010',
                view: false,
                master_id: 'ACC000',
                add: false,
                update: false,
                delete: false,
            },
            {
                id: 'acc.general-ledger-simple',
                title: 'General Ledger Simple List',
                type: 'basic',
                icon: 'heroicons_solid:document-text',
                link: '/accounting/general-ledger-simple',
                screen_id: 'ACC0011',
                view: false,
                master_id: 'ACC000',
                add: false,
                update: false,
                delete: false,
            },
            {
                id: 'acc.balance-sheet',
                title: 'Balance Sheet',
                type: 'basic',
                icon: 'heroicons_solid:scale',
                link: '/accounting/balance-sheet',
                screen_id: 'ACC0012',
                view: false,
                master_id: 'ACC000',
                add: false,
                update: false,
                delete: false,
            },
            {
                id: 'acc.income-statement-tree',
                title: 'Income Statement as Tree',
                type: 'basic',
                icon: 'heroicons_solid:chart-bar',
                link: '/accounting/income-statement-tree',
                screen_id: 'ACC0013',
                view: false,
                master_id: 'ACC000',
                add: false,
                update: false,
                delete: false,
            },
            {
                id: 'acc.account-lock',
                title: 'Account Lock',
                type: 'basic',
                icon: 'heroicons_solid:lock-closed',
                link: '/accounting/account-locking-manage',
                screen_id: 'ACC0014',
                view: false,
                master_id: 'ACC000',
                add: false,
                update: false,
                delete: false,
            },
            {
                id: 'acc.ledger-account-mapping',
                title: 'Ledger Account Mapping',
                type: 'basic',
                icon: 'heroicons_solid:map',
                link: '/accounting/ledger-account-mapping/manage',
                screen_id: 'ACC0015',
                view: false,
                master_id: 'ACC000',
                add: false,
                update: false,
                delete: false,
            },
            {
                id: 'acc.bank-reconciliation',
                title: 'Bank Reconciliation',
                type: 'basic',
                icon: 'heroicons_solid:building-library',
                link: '/accounting/bank-reconciliation-add',
                screen_id: 'ACC0017',
                view: true,
                master_id: 'ACC000',
                add: true,
                update: true,
                delete: false,
            },
            {
                id: 'acc.bank-reconciliation-manage',
                title: 'BRS History',
                type: 'basic',
                icon: 'heroicons_solid:clock',
                link: '/accounting/bank-reconciliation-manage',
                screen_id: 'ACC0018',
                view: true,
                master_id: 'ACC000',
                add: true,
                update: true,
                delete: false,
            },
            // ],
            // },
        ],
    },
];

export const compactNavigation: FuseNavigationItem[] = [
    {
        id: 'ct',
        title: 'Control Tower',
        tooltip: 'Holistics Business View',
        type: 'aside',
        icon: 'mat_outline:settings_input_antenna',
        screen_id: 'CLT000',
        view: false,
        add: false,
        update: false,
        delete: false,
        children: [], // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
    },
    {
        id: 'operations',
        title: 'Operations',
        tooltip: 'Operations',
        type: 'aside',
        icon: 'heroicons_outline:home',
        children: [], // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
        screen_id: 'OPR000',
        view: false,
        add: false,
        update: false,
        delete: false,
    },
    {
        id: 'acc',
        title: 'Accounting',
        tooltip: 'Ledger & Journals',
        type: 'aside',
        screen_id: 'ACC000',
        view: false,
        add: false,
        update: false,
        delete: false,
        icon: 'mat_outline:account_balance',
        children: [], // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
    },
    {
        id: 'hrs',
        title: 'Human Resource',
        subtitle: 'HR Management',
        type: 'aside',
        screen_id: 'HR000',
        view: false,
        add: false,
        update: false,
        delete: false,
        icon: 'mat_outline:settings_accessibility',
        children: [
            {
                id: 'hrs.streams',
                title: 'Streams',
                type: 'basic',
                icon: 'mat_solid:stream',
                link: '/hr/streams-manage',
                screen_id: 'HR001',
                view: false,
                add: false,
                update: false,
                delete: false,
                master_id: 'HR000',
            },
            {
                id: 'hrs.departments',
                title: 'Departments',
                type: 'basic',
                icon: 'feather:layers',
                link: '/hr/departments-manage',
                screen_id: 'HR002',
                view: false,
                add: false,
                update: false,
                delete: false,
                master_id: 'HR000',
            },
            {
                id: 'hrs.jobpositons',
                title: 'Job Positions',
                type: 'basic',
                icon: 'heroicons_solid:briefcase',
                link: '/hr/job-positions-manage',
                screen_id: 'HR003',
                view: false,
                add: false,
                update: false,
                delete: false,
                master_id: 'HR000',
            },
            {
                id: 'hrs.employee-master',
                title: 'Employee Master',
                type: 'basic',
                icon: 'mat_solid:people_alt',
                link: '/hr/employee/manage',
                screen_id: 'HR004',
                view: false,
                add: false,
                update: false,
                delete: false,
                master_id: 'HR000',
            },
        ],
    },
    {
        id: 'user',
        title: 'User Management',
        subtitle: '',
        type: 'aside',
        icon: 'mat_outline:supervised_user_circle',
        screen_id: 'USM000',
        view: false,
        add: false,
        update: false,
        delete: false,
        children: [
            {
                id: 'user.Manage-user-account',
                title: 'Manage User Account',
                type: 'basic',
                icon: 'mat_solid:account_box',
                link: '/user/user-account/manage',
                screen_id: 'USM002',
                master_id: 'USM000',
                view: false,
                add: false,
                update: false,
                delete: false,
            },
            {
                id: 'user.Manage-User-Roles',
                title: 'Manage User Roles',
                type: 'basic',
                icon: 'mat_solid:supervisor_account',
                link: '/user/user-roles/manage',
                screen_id: 'USM003',
                master_id: 'USM000',
                view: false,
                add: false,
                update: false,
                delete: false,
            },
            {
                id: 'user.Manage-user-Permission',
                title: 'Manage User Permission',
                type: 'basic',
                icon: 'mat_solid:person',
                link: '/user/manage-user-permission',
                screen_id: 'USM004',
                view: false,
                add: false,
                update: false,
                delete: false,
                master_id: 'USM000',
            },
            {
                id: 'user.Assign-Permission-Roles',
                title: 'Assign Permission to Roles',
                type: 'basic',
                icon: 'mat_solid:people',
                link: '/user/assign-permission-roles',
                screen_id: 'USM005',
                master_id: 'USM000',
                view: false,
                add: false,
                update: false,
                delete: false,
            },
            {
                id: 'user.menu-permission',
                title: 'Menu Permission',
                type: 'basic',
                icon: 'mat_solid:people',
                link: '/user/menu-permission/manage',
                screen_id: 'USM006',
                master_id: 'USM000',
                view: false,
                add: false,
                update: false,
                delete: false,
            },
        ],
    },

    // {
    //   id: 'email',
    //   title: 'Email Manager',
    //   subtitle: '',
    //   type: 'aside',
    //   icon: 'mat_outline:email',
    //   screen_id: 'EMI000',
    //   add: false,
    //   update: false,
    //   delete: false,
    //   children: [],
    // },

    {
        id: 'email',
        title: 'Email Manager',
        subtitle: '',
        type: 'aside',
        icon: 'mat_outline:email',
        screen_id: 'EMI000',
        add: false,
        update: false,
        delete: false,
        children: [
            // {
            //   id: 'email',
            //   title: 'Email Manager',
            //   subtitle: '',
            //   type: 'collapsable',
            //   icon: 'mat_outline:settings_accessibility',
            //   view: false,
            //   screen_id: 'EMI000',
            //   master_id: 'OPR00',
            //   add: false,
            //   update: false,
            //   delete: false,
            //   children: [
            {
                id: 'email.email-templates',
                title: 'Email Template',
                type: 'basic',
                icon: 'mat_solid:table_chart',
                link: '/email-manager/email-templates-manage',
                screen_id: 'EMI001',
                master_id: 'OPR00',
                add: false,
                update: false,
                delete: false,
            },
            {
                id: 'email.email-accounts',
                title: 'Email Accounts',
                type: 'basic',
                icon: 'mat_solid:email',
                link: '/email-manager/email-accounts-manage',
                screen_id: 'EMI002',
                master_id: 'OPR00',
                add: false,
                update: false,
                delete: false,
            },
            {
                id: 'email.email-send-delivered',
                title: 'Email Send/Delivered Status',
                type: 'basic',
                icon: 'mat_solid:send',
                link: '/email-manager/email-send-delivered',
                screen_id: 'EMI003',
                master_id: 'OPR00',
                add: false,
                update: false,
                delete: false,
            },
            //   ],
            // },
        ],
    },
    {
        id: 'reports',
        title: 'Reports',
        subtitle: '',
        type: 'aside',
        icon: 'mat_outline:receipt',
        children: [
            {
                id: 'reports.reports-runner',
                title: 'Reports Runner',
                type: 'basic',
                icon: 'mat_solid:account_box',
                link: '/reports/reports-runner',
                screen_id: 'REP001',
                view: false,
                master_id: 'OPR00',
                add: false,
                update: false,
                delete: false,
            },
            {
                id: 'reports.cash-flow',
                title: 'Cash Flow',
                type: 'basic',
                icon: 'mat_solid:account_box',
                link: '/reports/cash-flow-manage',
                screen_id: 'REP002',
                view: false,
                master_id: 'OPR00',
                add: false,
                update: false,
                delete: false,
            },
            {
                id: 'reports.bank-statement',
                title: 'Bank Statement',
                type: 'basic',
                icon: 'mat_solid:account_box',
                link: '/reports/bank-statement-manage',
                screen_id: 'REP003',
                view: false,
                master_id: 'OPR00',
                add: false,
                update: false,
                delete: false,
            },
        ],
        screen_id: 'REP000',
        view: false,
        add: false,
        update: false,
        delete: false,
    },
    // {
    //   id: 'ecommerce',
    //   title: 'Inventory',
    //   subtitle: '',
    //   type: 'aside',
    //   icon: 'mat_outline:inventory',
    //   children: [],
    //   screen_id: 'INV000',
    // },
    {
        id: 'settings',
        title: 'Settings',
        subtitle: '',
        type: 'aside',
        icon: 'mat_outline:settings_applications',
        children: [
            {
                id: 'settings.general',
                title: 'General',
                type: 'basic',
                icon: 'mat_solid:inventory',
                link: '/settings/general',
                screen_id: 'SET002',
                view: false,
                add: false,
                update: false,
                delete: false,
                master_id: 'SET000',
            },
            {
                id: 'settings.myPreference',
                title: 'My Preference',
                type: 'basic',
                icon: 'mat_solid:inventory',
                link: '/settings/preferences',
                screen_id: 'SET004',
                view: false,
                add: false,
                update: false,
                delete: false,
                master_id: 'SET000',
            },
        ],
        screen_id: 'SET000',
        view: false,
        add: false,
        update: false,
        delete: false,
    },
];
export const futuristicNavigation: FuseNavigationItem[] = [
    {
        id: 'example',
        title: 'Example',
        type: 'basic',
        icon: 'heroicons_outline:chart-pie',
        link: '/example',
    },
];
export const horizontalNavigation: FuseNavigationItem[] = [
    {
        id: 'example',
        title: 'Example',
        type: 'basic',
        icon: 'heroicons_outline:chart-pie',
        link: '/example',
    },
];
